import { callApiWithoutToken } from './api';

import { ApiResult } from '@/types/api';
import {
  DetailedAttendanceReservation,
  DropoffInfo,
  PickupInfo,
} from '@/types/attendanceReservation';

export type UpsertAttendanceReservationRequest = {
  date: string; // YYYY-MM-DD形式
  office_id: number;
  attendance_status: 'absent' | 'attend';
  absent_reason?: string;
  pickup_info?: PickupInfo;
  dropoff_info?: DropoffInfo;
  is_dinner?: boolean;
  notes?: string;
};

export const createReservation = async (
  line_id: string,
  accessToken: string,
  child_id: number,
  input: UpsertAttendanceReservationRequest
): Promise<ApiResult<DetailedAttendanceReservation>> => {
  const { status, result } = await callApiWithoutToken<DetailedAttendanceReservation>(
    `line/${line_id}/children/${child_id}/attendance-reservations`,
    'POST',
    accessToken,
    undefined,
    input
  );
  return { status, result };
};

export const updateReservation = async (
  line_id: string,
  accessToken: string,
  child_id: number,
  reservation_id: number,
  input: UpsertAttendanceReservationRequest
): Promise<ApiResult<DetailedAttendanceReservation>> => {
  const { status, result } = await callApiWithoutToken<DetailedAttendanceReservation>(
    `line/${line_id}/children/${child_id}/attendance-reservations/${reservation_id}`,
    'PUT',
    accessToken,
    undefined,
    input
  );
  return { status, result };
};
